import { Button, Col, Divider, Form, Input, Modal, Row, Select, Space, Switch } from "antd";
import { Pagina } from "../../../model/root/Pagina";
import { useRef, useState } from "react";
import { BiCheck, BiX } from "react-icons/bi";
import Colors from "../../../styles/Colors";
import { PlusOutlined } from "@ant-design/icons";
import { PostPantalles } from "../../../dao/root/PostPantalles";

interface IngredientModalProps {
    element: Pagina;
    visible: boolean;
    page: string;
    editar?: boolean;
    onClose: () => void;
    id_usu_log : string;
}

const PantallesModal: React.FC<IngredientModalProps> = ({element, visible, page, onClose, editar, id_usu_log}) => {
    const [form] = Form.useForm(); 
    const [items, setItems] = useState(['emails','beques','inscripcions','configuraciocasals','emailscasals','passarllista','alumnecasal',
        'propostes','generarpdf','rebuts','remeses','comandes','gestorcomandes'])
    const [name, setName] = useState('');
    const inputRef = useRef(null);
    const onNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setName(event.target.value);
    };
    const addItem = (e:  React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) =>{
        e.preventDefault();
        setItems(index => [...items, name || `New item ${index.length + 1}`]);
        setName('');
    };
    //Convierte el array de subpaginas en un string de subpagines separados por #
    const formatSubpagines = (subpagines: (string | undefined)[]): string => {
        return subpagines
            .filter(s => typeof s === 'string')
            .map(s => s as string)
            .join('#');
    };
    async function handleSubmit() {
        const id = await form.getFieldValue('id');
        const nom = await form.getFieldValue('nom');
        const descripcio = await form.getFieldValue('descripcio');
        const subpaginesArray = form.getFieldValue('subpagines') || [];
        const contenedor = await form.getFieldValue('contenedor');
        const extensio = await form.getFieldValue('extensio');
        const pantalla = await form.getFieldValue('pantalla');
        const tipus = await form.getFieldValue('tipus');
        const subpagines = formatSubpagines(subpaginesArray);
        await PostPantalles(id, nom, descripcio, subpagines, contenedor, extensio, pantalla, tipus, page, id_usu_log);
        await onClose();
    }

    const filterOption = (input: string, options?: { label: string; value: string }) =>
        (options?.label ?? '').toLowerCase().includes(input.toLowerCase());

    async function handleCancel() {

        await onClose();
    };
    if(!editar){
        return(
            <Modal
                title="Mostrar Pagina"
                open={visible}
                onCancel={handleCancel}
                footer={[
                    <>
                        <Button title={"Acceptar"} style={{backgroundColor: Colors.colors.color6}}
                                onClick={handleSubmit}><BiCheck/></Button>
                        {" "}
                        <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                onClick={handleCancel}><BiX/></Button>
                    </>
                ]}
                width={600}
            >
                <Form form={form} initialValues={element}>
                    <br/>
                    <Row gutter={[16, 16]}>
                        <Col span={42}>
                            <Form.Item label="ID" name="id">
                                <Input disabled/>
                            </Form.Item>
                            <Form.Item label="Nom" name="nom">
                                    <Input type="text" disabled/>
                            </Form.Item>
                            <Form.Item label="Descripcio" name="descripcio">
                                    <Input type="text" disabled/>
                            </Form.Item>
                            <Form.Item label="Subpagines" name="subpagines">
                                    <Select
                                        mode="multiple"
                                        style={{ width: 300 }}
                                        placeholder="Selecciona o afegeix subpagines"
                                        dropdownRender={(menu) => (
                                            <>
                                                {menu}
                                                <Divider style={{ margin: '8px 0' }} />
                                                <Space style={{ padding: '0 8px 4px' }}>
                                                    <Input
                                                        placeholder="Please enter item"
                                                        ref={inputRef}
                                                        value={name}
                                                        onChange={onNameChange}
                                                        onKeyDown={(e) => e.stopPropagation()}
                                                    />
                                                </Space>
                                            </>
                                        )}
                                    options={items.map(item => ({ label: item, value: item }))}
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    disabled
                                    />
                            </Form.Item>
                            <Form.Item label="Contenedor" name="contenedor">
                                    <Input type="text" disabled/>
                            </Form.Item>
                            <Form.Item label="Extensio" name="extensio">
                                    <Input type="text" disabled/>
                            </Form.Item>
                            <Form.Item label="Pantalla" name="pantalla">
                                <Select
                                    showSearch
                                    placeholder="Selecciona una pantalla"
                                    optionFilterProp="label"
                                    //onChange={onChange}
                                    //onSearch={onSearch}
                                    options={[
                                    {value: 'artiesports',label: 'Artiesports',},
                                    {value: 'menudesign',label: 'Menudesign',},
                                    {value: 'root',label: 'Root',},
                                    ]}
                                    disabled
                                />
                            </Form.Item>
                            <Form.Item label="Tipus" name="tipus">
                                <Switch disabled/>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        )
    }else{
    return(
        <Modal
            title="Crear/Editar Pagina"
            open={visible}
            onCancel={handleCancel}
            footer={[
                <>
                    <Button title={"Acceptar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={handleSubmit}><BiCheck/></Button>
                    {" "}
                    <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                            onClick={handleCancel}><BiX/></Button>
                </>
            ]}
            width={600}
        >
            <Form form={form} initialValues={element}>
                <br/>
                <Row gutter={[16, 16]}>
                    <Col span={42}>
                        <Form.Item label="ID" name="id">
                            <Input disabled/>
                        </Form.Item>
                        <Form.Item label="Nom" name="nom">
                                <Input type="text"/>
                        </Form.Item>
                        <Form.Item label="Descripcio" name="descripcio"
                            rules={[{ required: true, message: 'Aquest camp es obligatori'}]}>
                                <Input type="text"/>
                        </Form.Item>
                        <Form.Item label="Subpagines" name="subpagines">
                                <Select
                                    mode="multiple"
                                    style={{ width: 300 }}
                                    placeholder="Selecciona o afegeix subpagines"
                                    dropdownRender={(menu) => (
                                        <>
                                            {menu}
                                            <Divider style={{ margin: '8px 0' }} />
                                            <Space style={{ padding: '0 8px 4px' }}>
                                                <Input
                                                    placeholder="Please enter item"
                                                    ref={inputRef}
                                                    value={name}
                                                    onChange={onNameChange}
                                                    onKeyDown={(e) => e.stopPropagation()}
                                                />
                                                <Button type="text" icon={<PlusOutlined />} onClick={addItem}>
                                                    Add item
                                                </Button>
                                            </Space>
                                        </>
                                    )}
                                options={items.map(item => ({ label: item, value: item }))}
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                />
                        </Form.Item>
                        <Form.Item label="Contenedor" name="contenedor">
                                <Input type="text"/>
                        </Form.Item>
                        <Form.Item label="Extensio" name="extensio">
                                <Input type="text"/>
                        </Form.Item>
                        <Form.Item label="Pantalla" name="pantalla"
                        rules={[{ required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select
                                showSearch
                                placeholder="Selecciona una pantalla"
                                optionFilterProp="label"
                                //onChange={onChange}
                                //onSearch={onSearch}
                                options={[
                                {value: 'artiesports',label: 'Artiesports',},
                                {value: 'menudesign',label: 'Menudesign',},
                                {value: 'root',label: 'Root',},
                                ]}
                            />
                        </Form.Item>
                        <Form.Item label="Tipus" name="tipus">
                            <Switch />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    )}
}

export default PantallesModal;